import React from 'react';
import {connect} from 'react-redux';
import styles from './css/Planning.styl';
import Planner from './components/Planner';
import ReasonsBlock from './components/ReasonsBlock';
import Pricing from './components/Pricing';
import ArticlesCTA from './components/ArticlesCTA';
import ArticlesBlock from './components/ArticlesBlock';
import FindFuneralHomeCTA from './components/FindFuneralHomeCTA';
import ObitWriterCTA from './components/ObitWriterCTA';
import SearchCTA from './components/SearchCTA';
import {setCookie, getCookie} from '../../shared/utilities/cookies';

/**
 * Planning module
 * @class   Planning
 * @return  {JSX}     Returns the rendered module
 */
export class Planning extends React.Component {
  static propTypes = {
    ads: React.PropTypes.object.isRequired,
    location: React.PropTypes.object.isRequired,
  };

  /**
   * Planning React Component constructor
   * @param       {Object}    props   Passed in props
   * @param       {Object}    context Used for flux store
   * @constructs  {Planning}
   * @return      {Undefined} Returns nothing
   */
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    if (this.props.location.pathname) {
      const pathParts = this.props.location.pathname.split('/');

      if (pathParts.length > 3) {
        const affiliateCookie = getCookie('LegacyGlobal');
        const cookieValue = `AffiliateSiteName=${pathParts[3].split('?')[0]}`;

        if (!affiliateCookie.includes(cookieValue)) {
          setCookie('LegacyGlobal', cookieValue, 4 / 24);
        }
      }
    }
  }

  /**
   * React Component render.
   * @return {JSX} Planning page rendered.
   */
  render() {
    return (
      <div className={styles.Planning}>
        <div className={styles.Content}>
          <div className={styles.Container}>
            <Planner />
            <ReasonsBlock />
            <Pricing />
            <ArticlesCTA />
            <ArticlesBlock />
            <div className={styles.Ctas}>
              <FindFuneralHomeCTA />
              <ObitWriterCTA />
              <SearchCTA />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
const mapStateToProps = state => ({
  ads: state.adStore,
});

export default connect(mapStateToProps)(Planning);



// WEBPACK FOOTER //
// ./src/reactModules/pages/Planning/index.js